import { render, staticRenderFns } from "./ShowActivitiesDialog.vue?vue&type=template&id=8838293c&scoped=true"
import script from "@/views/RosterTemplates/ShowActivitiesDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/RosterTemplates/ShowActivitiesDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/RosterTemplates/show-activities-dialog.scss?vue&type=style&index=0&id=8838293c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8838293c",
  null
  
)

export default component.exports